export const type = 'preferences';

export interface PreferencesState {
    marketingEmailStatus: number;
    pushNotificationsStatus: number;
    isFetching: boolean;
    isSaving: boolean;
    errorMessage: string | undefined;
}

export const initialState: PreferencesState = {
    marketingEmailStatus: 0,
    pushNotificationsStatus: 0,
    isFetching: false,
    isSaving: false,
    errorMessage: undefined,
};
